// Helpers compartidos por los módulos de render.
// Basado en el Analizador Cabrillo original de XQ2OP. Ver
// src/cabrillo/CREDITOS.md. render ≠ motor: estos helpers son puramente
// de presentación (formato de texto, color, lectura de CSS), no calculan
// nada analítico — eso vive en motor.js/modelo.js.

import { BCOL } from '../constantes.js';

export const pad = (n) => String(n).padStart(2, '0');

export const fmt = (ms) => {
    const d = new Date(ms);
    return pad(d.getUTCDate()) + '/' + pad(d.getUTCMonth() + 1) + ' ' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes());
};

export const BC = (i) => BCOL[i % BCOL.length];

/** Lee una variable CSS del elemento raíz del Analizador nativo (no de :root global de CM). */
export function css(el, variable) {
    return getComputedStyle(el).getPropertyValue(variable).trim();
}

/**
 * Vuelve a llamar `callback` cuando `el` cambia de tamaño real
 * (ResizeObserver legítimo: no es un hack para forzar visibilidad como
 * el que se usaba con el iframe, es observar canvases nativos que de
 * verdad cambian de tamaño — resize de ventana, zoom, abrir/cerrar
 * DevTools, cambios de layout del contenedor, etc.).
 *
 * Sirve de red de seguridad ante el primer render: si en algún momento
 * un canvas se monta mientras su contenedor todavía mide 0 (por ejemplo,
 * por error de orden en quien lo monta), el ResizeObserver dispara un
 * redibujado apenas el contenedor obtiene dimensiones reales, sin
 * necesidad de que el usuario fuerce un resize manual.
 *
 * Sin polling ni intervalos: el `requestAnimationFrame` interno es solo
 * para coalescer notificaciones repetidas del propio ResizeObserver
 * (evita el warning "loop completed with undelivered notifications"),
 * no una espera arbitraria.
 *
 * @param {Element} el
 * @param {() => void} callback
 * @returns {() => void} función para dejar de observar
 */
export function observarRedimension(el, callback) {
    if (!('ResizeObserver' in window)) {
        return () => {};
    }
    let pendiente = false;
    const ro = new ResizeObserver(() => {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(() => {
            pendiente = false;
            callback();
        });
    });
    ro.observe(el);
    return () => ro.disconnect();
}
